'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FullScreenModal = require('../modal/FullScreenModal');

var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);

var _StaticHtml = require('./StaticHtml');

var _StaticHtml2 = _interopRequireDefault(_StaticHtml);

require('./StaticPage.scss');

require('./Legal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Styles


// Components
// Lib
var StaticPage = function StaticPage(_ref) {
    var page = _ref.routeParams.page;
    return _react2.default.createElement(
        _FullScreenModal2.default,
        { className: 'StaticPage' },
        _react2.default.createElement(_StaticHtml2.default, { htmlName: page })
    );
};

StaticPage.propTypes = {
    routeParams: _propTypes2.default.object.isRequired
};

exports.default = StaticPage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/static/StaticPage.js
// module id = 1932
// module chunks = 0